import HorizontalFlex from '../../../components/flex_layouts/HorizontalFlex';
import styled from '@emotion/styled';
import Colors from '../../../components/theme/colors';

export const TableCellShared = styled(HorizontalFlex)<{ isLastItem?: boolean; category: string }>`
  max-width: 260px;
  width: 100%;

  @media print {
    padding: 8px;
  }
`;
